/* eslint-disable */
"use client";

import Link from "next/link";
import styles from "./style.module.scss";
import clsx from "clsx";
import { useSetSearchParams } from "@/hooks/useSetSearchParams";
import { calculateTotalPages } from "@/utils";
import * as Icon from "@/components/tools/icons";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

type Props = {
  total: number;
  searchParams?: any;
};

export default function Pagination({ total }: Props) {
  const searchParams = useSearchParams(); // Get search params
  const { setSearchParams } = useSetSearchParams(); // Custom hook for setting params
  const currentPage = Number(searchParams.get("page")) || 1;
  var [limitPage, setLimitPage] = useState(total);
  const maxPage = calculateTotalPages(limitPage || 1);

  useEffect(() => {
    if (total && total > 100000) {
      total = 100000;
      setLimitPage(total);
    }
  }, []);

  return (
    <div className={styles.pagination}>
      <div className={styles.left}>
        <Link
          className={clsx(currentPage === 1 && styles.disabled)}
          href={setSearchParams("page", "1")}
        >
          First
        </Link>
        <Link
          className={clsx(currentPage === 1 && styles.disabled)}
          href={setSearchParams("page", String(currentPage - 1))}
        >
          <Icon.Arrow />
        </Link>
      </div>
      <div className={styles.center}>
        {currentPage} / {maxPage}
      </div>
      <div className={styles.right}>
        <Link
          className={clsx(currentPage === maxPage && styles.disabled)}
          href={setSearchParams("page", String(maxPage))}
        >
          Last
        </Link>
        <Link
          className={clsx(currentPage === maxPage && styles.disabled)}
          href={setSearchParams("page", String(currentPage + 1))}
        >
          <Icon.Arrow />
        </Link>
      </div>
    </div>
  );
}
